import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';

export const adminRoleGuard: CanActivateFn = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  const user = authService.loggedUser$.value;

  if (!user || !user.roles || user.roles.length === 0) {
    router.navigateByUrl('/auth/company-select');
    return false;
  }

  const isAdmin = user.roles.some(role => !!role?.isAdmin);

  if (!isAdmin) {
    router.navigateByUrl('/auth/company-select');
    return false;
  }

  return true;
};

